import React from 'react'
import { Outlet } from 'react-router-dom'

function Authorization() {
  return (
    <div><Outlet /></div>
  )
}

export default Authorization